function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadState } from '@nextcloud/initial-state';
import { mapActions, mapGetters, mapState } from 'vuex';
import Checkbox from './Checkbox';
import { isActivityEnabled } from '../helpers/settings';
export default {
  name: 'ActivityGrid',
  components: {
    Checkbox: Checkbox
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['checkedActivities'])), mapState(['methods', 'activityGroups', 'emailEnabled', 'isEmailSet', 'settingBatchtime'])),
  methods: _objectSpread(_objectSpread({
    isActivityEnabled: isActivityEnabled
  }, mapActions(['toggleMethodForMethodAndActivity', 'toggleMethodForGroup', 'toggleMethodsForActivity'])), {}, {
    actionName: function actionName(method) {
      if (method === 'email') {
        return t('activity', 'Send email');
      } else {
        return t('activity', 'Send push notification');
      }
    }
  })
};